import { apiClient } from "@/lib/apiClient";
import type { EventInput } from "@fullcalendar/core";
import type {
  EducationCalendarEventDto,
  EducationCalendarEventKind,
  EducationCalendarEventsResponseData,
} from "../types/education-calendar-api.types";

const ENDPOINT = "/api/admin/education-calendar/events";

export interface GetEducationCalendarEventsParams {
  /** ISO tarih/datetime — görünür aralık başı */
  from?: string;
  /** ISO tarih/datetime — görünür aralık sonu */
  to?: string;
}

const DEFAULT_COLORS: Record<
  EducationCalendarEventKind,
  { backgroundColor: string; borderColor: string }
> = {
  training: { backgroundColor: "#1d4ed8", borderColor: "#1e40af" },
  request_deadline: {
    backgroundColor: "rgba(234, 179, 8, 0.25)",
    borderColor: "rgba(202, 138, 4, 0.4)",
  },
  request_window: {
    backgroundColor: "#ca8a04",
    borderColor: "#a16207",
  },
};

function mapDtoToEventInput(dto: EducationCalendarEventDto): EventInput {
  const base = dto.extendedProps ?? { kind: "training" as const };
  const kind = base.kind;
  const fallback = DEFAULT_COLORS[kind] ?? DEFAULT_COLORS.training;
  return {
    id: dto.id,
    title: dto.title,
    start: dto.start,
    end: dto.end,
    allDay: dto.allDay,
    display: dto.display,
    backgroundColor: dto.backgroundColor ?? fallback.backgroundColor,
    borderColor: dto.borderColor ?? fallback.borderColor,
    extendedProps: { ...base, kind },
  };
}

/**
 * Eğitim yöneticisi takvimi etkinlikleri.
 * Backend henüz yoksa veya hata olursa caller yönetir.
 */
export async function getEducationCalendarEvents(
  params?: GetEducationCalendarEventsParams,
): Promise<EventInput[]> {
  const { data } = await apiClient.get<{
    success?: boolean;
    data?: EducationCalendarEventsResponseData;
    message?: string;
  }>(ENDPOINT, {
    params:
      params?.from || params?.to
        ? { from: params.from, to: params.to }
        : undefined,
  });

  const raw = data?.data?.events;
  if (!Array.isArray(raw)) return [];

  return raw.map(mapDtoToEventInput);
}
